import { render, staticRenderFns } from "./SlotBedType.vue?vue&type=template&id=1557fba6&"
import script from "./SlotBedType.vue?vue&type=script&lang=js&"
export * from "./SlotBedType.vue?vue&type=script&lang=js&"
import style0 from "./SlotBedType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports